export var StatusEnum;
(function (StatusEnum) {
    StatusEnum["DRAFT"] = "draft";
    StatusEnum["DEACTIVATED"] = "deactivated";
    StatusEnum["DELAYED"] = "delayed";
    StatusEnum["PUBLISHED"] = "published";
    StatusEnum["OTHER"] = "other";
})(StatusEnum || (StatusEnum = {}));
